{
  "login-page": {
    "buttons": {
      "next": "Weiter",
      "sign-up": "Neuen Account erstellen",
      "update-password": "Passwort aktualisieren",
      "use-phone-to-login": "Anmeldung mit Telefonnummer",
      "use-email-to-login": "Anmeldung mit E-Mail"
    },
    "text": {
      "title": "Anmeldung",
      "subtitle": "Anmeldung bei Beauty Booking",
      "email": "Ihre E-Mail",
      "or": "ODER",
      "password": "Passwort",
      "password-hint": "Sie müssen Ihr Passwort aktualisieren",
      "username": "Benutzername",
      "username-hint": "Sie müssen Ihre E-Mail-Adresse oder Telefonnummer eingeben"
    }
  }
}
